import { NgModule } from "@angular/core";
import { TableModule } from "primeng/table";
import { DatePipe, JsonPipe, KeyValuePipe, NgClass, NgForOf, NgIf, NgOptimizedImage, NgStyle } from "@angular/common";
import { ButtonModule } from "primeng/button";
import { PaginatorModule } from "primeng/paginator";
import { SelectButtonModule } from "primeng/selectbutton";
import { AccordionModule } from "primeng/accordion";
import { AvatarModule } from "primeng/avatar";
import { BadgeModule } from "primeng/badge";
import {
  MedBtnModule, MedBubbleModule,
  MedCheckboxModule, MedDatepickerModule, MedInputModule,
  MedLeftAsideModule, MedMultiSelectModule,
  MedPaginationModule,
  MedRadioGroupModule, MedSelectModule,
  MedSidebarModule,
} from "@mk/med-ui";
import { SuppliesComponent } from "@app/components/supplies/supplies.component";
import { AvailabilityComponent } from "@app/components/supplies/availability/availability.component";
import { GoodsComponent } from "@app/components/supplies/goods/goods.component";
import { PageTitleModule } from "@app/components/page-title/page-title.module";
import { TableRowDirective } from "@app/shared/directives/tableRow.directive";
import { SidebarModule } from "primeng/sidebar";
import {
    MedIconChevronLeftModule,
    MedIconChevronRightModule,
    MedIconCloseModule,
    MedIconHistoryModule, MedIconRefreshModule,
} from "@mk/med-icons";
import { LoaderModule } from "@app/components/loader/loader.module";
import { TooltipModule } from "primeng/tooltip";
import {OverlayPanelModule} from "primeng/overlaypanel";

@NgModule({
  declarations: [
    SuppliesComponent,
    GoodsComponent,
    AvailabilityComponent,
    TableRowDirective,
  ],
    imports: [
        TableModule,
        MedBtnModule,
        NgForOf,
        KeyValuePipe,
        NgIf,
        NgOptimizedImage,
        DatePipe,
        ButtonModule,
        PaginatorModule,
        SelectButtonModule,
        NgStyle,
        AccordionModule,
        AvatarModule,
        BadgeModule,
        PageTitleModule,
        MedPaginationModule,
        MedRadioGroupModule,
        NgClass,
        MedCheckboxModule,
        MedSidebarModule,
        MedLeftAsideModule,
        SidebarModule,
        MedIconHistoryModule,
        MedIconCloseModule,
        MedMultiSelectModule,
        MedSelectModule,
        MedDatepickerModule,
        LoaderModule,
        MedInputModule,
        MedIconChevronLeftModule,
        MedIconChevronRightModule,
        TooltipModule,
        JsonPipe,
        OverlayPanelModule,
        MedIconRefreshModule
    ],
  exports: [
    SuppliesComponent,
    GoodsComponent,
    AvailabilityComponent,
  ],
})
export class SuppliesModule {}
